import { Header, Radio, type RadioProps, Segment } from '@mairistem/composants';
import React from 'react';
import './RadioSegment.css';

type RadioSegmentProps = Pick<
	RadioProps,
	'checked' | 'disabled' | 'onClick'
> & {
	content: string;
	subheader: string;
};

const RadioSegment = ({
	checked,
	content,
	disabled = false,
	onClick,
	subheader,
}: RadioSegmentProps) => (
	<Segment>
		<Radio
			checked={checked}
			disabled={disabled}
			label={
				// biome-ignore lint/a11y/noLabelWithoutControl: Label semantic
				<label className="radioSegmentLabel">
					<Header content={content} size="small" subheader={subheader} />
				</label>
			}
			onClick={onClick}
		/>
	</Segment>
);

export default RadioSegment;
